import { LockKeyhole } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { SidebarMenuButton } from '@/components/ui/sidebar';
import { HOME_TOUR_CLASSES } from '@/constants/tour/classNames';

interface SidebarMenuItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: React.ComponentType<any>;
  label: string;
  path: string;
  isLocked: boolean;
}

export const SidebarMenuItem = ({
  icon: Icon,
  label,
  path,
  isLocked,
}: SidebarMenuItemProps) => {
  const location = useLocation();

  // Map label to appropriate tour class constant
  const getClassName = (label: string): string => {
    switch (label) {
      case 'Home':
        return HOME_TOUR_CLASSES.SIDEBAR_HOME_BUTTON;
      case 'Territories':
        return HOME_TOUR_CLASSES.SIDEBAR_TERRITORIES_BUTTON;
      case 'Financial Overview':
        return HOME_TOUR_CLASSES.SIDEBAR_FINANCIAL_OVERVIEW_BUTTON;
      case 'Library':
        return HOME_TOUR_CLASSES.SIDEBAR_LIBRARY_BUTTON;
      case 'Ask Aimei':
        return HOME_TOUR_CLASSES.SIDEBAR_ASK_AIMEI_BUTTON;
      default:
        // Fallback to original dynamic generation for unknown labels
        return `sidebar-${label.toLowerCase().replace(/\s+/g, '-')}-button`;
    }
  };

  const className = getClassName(label);

  return (
    <SidebarMenuButton
      asChild
      isActive={location.pathname === path}
      disabled={isLocked}
      className={className}
    >
      <Link to={path} className="flex items-center justify-between">
        <div className="flex items-center gap-3 overflow-hidden">
          <Icon size={20} />
          <span className="truncate">{label}</span>
        </div>
        {isLocked && <LockKeyhole className="h-4 w-4" />}
      </Link>
    </SidebarMenuButton>
  );
};
